import MABAA030 from '../../pages/Memember/MABAA030';
import MABAA040 from '../../pages/Memember/MABAA040';
import MABAA060 from '../../pages/Memember/MABAA060';
import MABAA061 from '../../pages/Memember/MABAA061';
import MABAA080 from '../../pages/Memember/MABAA080';
import MABAA090 from '../../pages/Memember/MABAA090';
import MABAA100 from '../../pages/Memember/MABAA100';
import MABAA110 from '../../pages/Memember/MABAA110';
import MABAA120 from '../../pages/Memember/MABAA120';

const routersWidthSidebar = [
    { path: '/mabaa032-:id', element: MABAA030 },
    { path: '/mabaa042-:id', element: MABAA040 },
    { path: '/mabaa063-:id', element: MABAA060 },
    { path: '/mabaa064-:id', element: MABAA061 },
    { path: '/mabaa072-:id', element: MABAA030 },
    { path: '/mabaa082-:id', element: MABAA080 },
    { path: '/mabaa092-:id', element: MABAA090 },
    { path: '/mabaa102-:id', element: MABAA100 },
    { path: '/mabaa112-:id', element: MABAA110 },
    { path: '/mabaa122-:id', element: MABAA120 },
    { path: '/mabaa062-:id', element: MABAA061 },
];
export default routersWidthSidebar;
